import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import i18next from "i18next";
import ItemInjector from "@mnjsplatform/components/lib/common/ItemInjector";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import PopupWrapper from "../Common/PopupWrapper";
import editorType from "@mnjsplatform/data/lib/utils/editorType";
import SubgridInline from "@mnjsplatform/components/lib/common/Subgrid/SubgridInline";
import MnComboInline2 from "@mnjsplatform/components/lib/common/Dropdown/MnComboInline2";

export default (props) => {
    return <ItemInjector key={`${props.methodName}_${props.rowKey.AppPersIntId}`}
                         dataItem={{
                             controller: props.controller,
                             methodName: props.methodName,
                             withParamset: false,
                             fieldName: props.rowKey.AppPersIntId
                         }}><ConnectedRequestForm {...props} /></ItemInjector>
};

//const customFieldExMap = {}

class RequestForm extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isDataReady: false
        };
    }

    componentDidMount() {
        this.initialize();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.rowKey.AppPersIntId !== prevProps.rowKey.AppPersIntId
            || this.props.updateStateFlag !== prevProps.updateStateFlag) {
            this.initialize();
        }
    }

    initialize = async () => {
        try {
            this.setState({isDataReady: false});
            try {
                await this.props.dispatch(this.props.dataItem.reset());
                await this.props.dispatch(this.props.dataItem.execute(this.props.rowKey, {
                    withParams: false,
                    newItem: true
                }));
            } catch (e) {
                console.error(e);
            }
        } finally {
            this.setState({isDataReady: true})
        }
    }
    sendRequest = async () => {
        const self = this;
        await self.props.dispatch(self.props.dataItem.save(0));
        if (!self.props.dataItem.isError) {
            await self.props.dispatch(self.props.AppPers_Send.execute(self.props.rowKey));
            if (!self.props.AppPers_Send.isError) {
                return self.onClose({refresh: true, cancel: false, save: false});
            }
        }
    }
    openPrintForm = async () => {
        await this.props.dispatch(this.props.dataItem.save(0));
        if (!this.props.dataItem.isError) {
            await this.props.dispatch(this.props.AppPers_CheckEmpty.execute(this.props.rowKey));
            if (!this.props.AppPers_CheckEmpty.isError) {
                return this.onClose({showPrintForm: true, rowKey: this.props.rowKey, cancel: false, save: false});
            }
        }
    }
    renderButtons = () => {
        const row = this.props.dataItem.getRow(0);
        return (<div className="modal-footer text-right">
            {
                row.IsPaper === 1 &&
                <button type="button"
                        className="btn btn-regular -goahead ml1ex"
                        onClick={this.openPrintForm}>{i18next.t("Print")}</button>
            }
            {
                !this.props.readOnly && row.IsPaper === 0 &&
                <button type="button"
                        className="btn btn-regular -goahead ml1ex"
                        onClick={this.sendRequest}>{i18next.t("SignAndSendToManagerAndHR")}</button>
            }
            {
                !this.props.readOnly ?
                    <>
                        <button type="button" className="btn btn-regular -goahead"
                                onClick={() => this.onClose({
                                    refresh: true,
                                    cancel: true,
                                    save: false
                                })}>{i18next.t("Delete")}</button>
                        {/*
                        <button type="button" className="btn btn-regular -goahead"
                                onClick={() => this.onClose({refresh: true, cancel: false, save: true})}>{i18next.t("Save")}</button>
*/}
                        <button type="button" className="btn btn-regular"
                                onClick={() => this.onClose({
                                    refresh: true,
                                    cancel: true,
                                    save: false
                                })}>{i18next.t("Cancel")}</button>
                    </>
                    :
                    <button type="button" className="btn btn-regular"
                            onClick={() => this.onClose({
                                refresh: false,
                                cancel: false,
                                save: false
                            })}>{i18next.t("Close")}</button>
            }
        </div>)
    }
    onClose = async (props) => {
        if (props.cancel) {
            await this.props.dispatch(this.props.AppPers_Del.execute(this.props.rowKey));
            if (!this.props.AppPers_Del.isError) {
                if (this.props.onClose)
                    return this.props.onClose(props);
            }
        } else if (props.save) {
            await this.props.dispatch(this.props.dataItem.save(0));
            if (!this.props.dataItem.isError) {
                if (this.props.onClose)
                    return this.props.onClose(props);
            }
        } else {
            if (this.props.onClose)
                return this.props.onClose(props);
        }
    }

    render() {
        if (!this.state.isDataReady || this.props.dataItem.rowsCount() === 0)
            return null;

        return (
            <PopupWrapper popupVisible={true}
                          title={this.props.title}
                          staticTitle={i18next.t(`RequestToChangeWorkSchedule`)}
                          maxWidthBody="700px"
                          onClose={() => this.onClose({refresh: false, save: false})}
                          renderButtons={this.renderButtons}>
                <PlaceholderWrapper placeholderId={`${this.props.rowKey.AppPersIntId}`}
                                    title={i18next.t('RequestToChangeWorkSchedule')} canCollapse={false}
                                    showSplitterLine={false} collapsed={false} showHeaderTitle={false}
                                    showInstruction={false}>
                    <ComplexParam dataItem={this.props.dataItem} renderParams={this.renderParams}
                        //customFieldExMap={this.customFieldExMap}
                                  readOnly={this.props.readOnly}/>
                </PlaceholderWrapper>
            </PopupWrapper>
        );
    }

    headerCellStyleProvider = () => {
        return {textAlign: 'center'};
    }

    renderSubgridRowEx = (rowParams) => {
        const self = this;
        const getFieldControl = (dataItem, rowIndex, row, fieldName) => {
            const fieldInfo = dataItem.getFieldInfo(fieldName);
            if (fieldInfo.Name === 'sHoursDel') {
                return <MnComboInline2
                    parentDataItem={dataItem}
                    fieldInfo={fieldInfo}
                    rootPath={this.props.rootPath + "_" + fieldName}
                    rowIndex={rowIndex}
                    readOnly={self.props.readOnly || row.ReadOnlyRow === 1 || dataItem.getFieldIsReadOnly(fieldInfo, rowIndex)}
                    onSelected={async () => {
                        await self.props.dispatch(dataItem.save(rowIndex));
                    }}
                    classNameValue="text-center"
                />
            } else {
                return dataItem.getField(rowIndex, fieldName)
            }
            /*<InputFieldInline fieldInfo={fieldInfo}
                                     dispatch={self.props.dispatch}
                                     readOnly={self.props.readOnly || row.ReadOnlyRow === 1 || dataItem.getFieldIsReadOnly(fieldInfo, rowIndex)}
                                     rowIndex={rowIndex}
                                     dataItem={dataItem}
                                     formattedVal={row[fieldName]}
                                     onEndEditField={async () => {
                                         await self.props.dispatch(dataItem.save(rowIndex));
                                     }}
                                     autoApplyParams={false}/>*/
        }

        return (<tr key={rowParams.rowIndex}>
            <td align="center"></td>
            {rowParams.dataItem.rawData.ResultFieldInfo.map((fieldInfo, fieldIndex) => {
                if (!fieldInfo.IsHidden) {
                    return <td
                        align="center">{getFieldControl(rowParams.dataItem, rowParams.rowIndex, rowParams.row, fieldInfo.Name)}</td>
                }
            })}
        </tr>)
    }
    renderParams = (h) => {
        return (<div className="row">
            <div className="col-md-12">
                {h.fs.map((fieldDescriptor) => {
                    const fn = fieldDescriptor.Name;
                    if (fieldDescriptor.fieldInfo.EditorType === editorType.EditSubGrid) {
                        return <div key={fn} className="row">
                            <div className="col-md-12 font-weight-bold text-center">
                                <SubgridInline
                                    fieldInfo={fieldDescriptor.fieldInfo}
                                    readOnly={this.props.readOnly}
                                    rowIndex={this.props.dataItem.getCurrentRowIndex()}
                                    dataItem={this.props.dataItem}
                                    path={`${this.props.rootPath}_${fieldDescriptor.fieldInfo.Name}`}
                                    renderRowEx={this.renderSubgridRowEx}
                                    formattedVal={<><i className="fa fa-table"/>&nbsp;{h.lbl(fn)}</>}
                                    showEditColumn={false}
                                    headerCellStyleProvider={this.headerCellStyleProvider}
                                />
                            </div>
                        </div>;
                    }
                    return (<React.Fragment key={fn}>
                        <div className="row">
                            <div className="col-md-3 field-title">
                                {h.lbl(fn)}:
                            </div>
                            <div className="col-md-9">
                                {h.ed(fn)}
                            </div>
                        </div>
                        <hr/>
                    </React.Fragment>)
                })}
            </div>
        </div>)
    }
}

RequestForm.propTypes = {
    dispatch: PropTypes.func.isRequired,
    methodName: PropTypes.string,
    controller: PropTypes.string,
    rowKey: PropTypes.object,
    dataItem: PropTypes.object,
    updateStateFlag: PropTypes.any,
    title: PropTypes.string,
    readOnly: PropTypes.bool,
    AppPers_Del: PropTypes.object,
    AppPers_Send: PropTypes.object,
    AppPers_CheckEmpty: PropTypes.object
}

RequestForm.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        dataItem: ownProps.getItemState(state),
        AppPers_Del: state.dailyChartState.AppPers_Del,
        AppPers_Send: state.dailyChartState.AppPers_Send,
        AppPers_CheckEmpty: state.dailyChartState.AppPers_CheckEmpty
    }
}

const ConnectedRequestForm = connect(mapStateToProps)(RequestForm);